
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-and-events",
      function () {
        return require("private-next-pages/news-and-events/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-and-events"])
      });
    }
  